import { faPenField } from '@fortawesome/pro-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import React, {
  FunctionComponent,
  SyntheticEvent,
  useRef,
  useState,
} from 'react'
import { useTranslation } from 'react-i18next'

import Button from '../../App/Components/Button/Button'
import TextInput from '../../App/Components/Form/TextInput/TextInput'
import { ICustomer } from '../interfaces/ICustomer'

import { IProps } from './IProps'

const InvoiceData: FunctionComponent<IProps> = props => {
  const [t] = useTranslation()
  const [customer, setCustomer] = useState(props.customer)
  const [showErrors, setShowErrors] = useState<boolean>(false)
  const companyNameRef = useRef<HTMLInputElement>(null)
  const companyStreetRef = useRef<HTMLInputElement>(null)
  const companyZipRef = useRef<HTMLInputElement>(null)
  const companyCityRef = useRef<HTMLInputElement>(null)
  const companyVatRef = useRef<HTMLInputElement>(null)

  const { name, street, postal, city, vatNumber } =
    props.customer.invoiceInformation
  const onInputChange = (name: string, value: any) => {
    const newCustomer: ICustomer = {
      ...customer,
      invoiceInformation: {
        ...customer.invoiceInformation,
        [name]: value,
      },
    }
    setCustomer(newCustomer)
  }

  const onFillIn = (e: React.SyntheticEvent<HTMLButtonElement>) => {
    e.preventDefault()

    const newCustomer: ICustomer = {
      ...customer,
      invoiceInformation: {
        ...customer.invoiceInformation,
        name:
          name !== null && name !== undefined ? name : props.customer.fullName,
        street:
          street !== null && street !== undefined
            ? street
            : props.customer.address,
        postal:
          postal !== null
            ? postal
            : props.customer.zipcode !== null
            ? props.customer.zipcode
            : '',
        city:
          city !== null
            ? city
            : props.customer.city !== null
            ? props.customer.city
            : '',
        vatNumber: vatNumber !== null ? vatNumber : '',
      },
    }

    setCustomer(newCustomer)
  }

  const onSubmit = (e: SyntheticEvent<HTMLFormElement>) => {
    e.preventDefault()
    if (isValid()) {
      props.onSubmit(customer)
      setShowErrors(false)
    } else {
      setShowErrors(true)
    }
  }

  const isValid = (): boolean => {
    return (
      !!customer.invoiceInformation.name &&
      !!customer.invoiceInformation.street &&
      !!customer.invoiceInformation.postal &&
      !!customer.invoiceInformation.city &&
      !!customer.invoiceInformation.vatNumber
    )
  }

  return (
    <>
      <form onSubmit={onSubmit}>
        <TextInput
          key={'company-name'}
          label={t('Company name')}
          value={customer.invoiceInformation.name || ''}
          onChange={event => onInputChange('name', event.currentTarget.value)}
          inputRef={companyNameRef}
          error={
            showErrors && !customer.invoiceInformation.name
              ? 'This field is required'
              : null
          }
        />

        <TextInput
          key={'company-street'}
          label={t('Street')}
          value={customer.invoiceInformation.street || ''}
          onChange={event => onInputChange('street', event.currentTarget.value)}
          inputRef={companyStreetRef}
          error={
            showErrors && !customer.invoiceInformation.street
              ? 'This field is required'
              : null
          }
        />
        <TextInput
          key={'company-zip'}
          label={t('Postal code')}
          value={customer.invoiceInformation.postal || ''}
          onChange={event =>
            onInputChange('postal', event.currentTarget.value)
          }
          inputRef={companyZipRef}
          error={
            showErrors && !customer.invoiceInformation.postal
              ? 'This field is required'
              : null
          }
        />
        <TextInput
          key={'company-city'}
          label={t('City')}
          value={customer.invoiceInformation.city || ''}
          onChange={event => onInputChange('city', event.currentTarget.value)}
          inputRef={companyCityRef}
          error={showErrors && !customer.invoiceInformation.city ? 'This field is required' : null}
        />
        <TextInput
          key={'company-vat'}
          label={t('VAT number')}
          value={customer.invoiceInformation.vatNumber || ''}
          onChange={event =>
            onInputChange('vatNumber', event.currentTarget.value)
          }
          inputRef={companyVatRef}
          error={
            showErrors && !customer.invoiceInformation.vatNumber
              ? 'This field is required'
              : null
          }
        />
        <Button onClick={e => onFillIn(e)}>
          <FontAwesomeIcon icon={faPenField} />
        </Button>
        <Button type="submit">{t('Submit')}</Button>
      </form>
    </>
  )
}

export default InvoiceData
